export const chipStyles = {
  height: 'fit-content',
  flexShrink: 0,
  maxWidth: 'none',
  whiteSpace: 'nowrap',

  '.MuiChip-label': {
    fontFamily: 'Helvetica Neue, sans-serif',
    fontStretch: 'condensed',
    fontWeight: 900,
    fontSize: '16px',
    lineHeight: '24px',
    textOverflow: 'unset',
    whiteSpace: 'nowrap',
    overflow: 'visible',
    textTransform: 'capitalize'
  }
}

export const chipImageStyles = {
  height: '1rem',
  filter: 'invert(100%)'
}
